(function (global, factory) {
    if (typeof exports === 'object') {
        module.exports = factory( require('./api.js'), require('jquery') );
    } else if ( typeof define === 'function' && define.amd ) {
        define(['api', 'jquery'], factory);
    }
}(this, function (apiModule, jQuery) {

    var $ = jQuery;

    var API = apiModule.api,
        Service = apiModule.Service,
        ConceptsService = new Service({
            name: 'concept',
            url: '/py/api2/concepts/',
            allowedMethods: ['get','post','put'],
            interfaces: [
                'limit', 'noLimit', 'search',
                'filter', 'removeFilter', 'clearQueryObject',
                'addToLast', 'enableLast', 'disableLast', 'disableCustom'
            ],
            methodProviders: {
                'get': getProvider
            }
        });

    function getProvider(ajaxSettings){
        var filter = this.queryObject.filter,
            limit = this.queryObject.limit,
            search = this.queryObject.search,
            noLast = this.queryObject.noLast,
            noCustom = this.queryObject.noCustom,
            tmpLimitArray = [],
            _ajaxSettings =  ajaxSettings || {};
        _ajaxSettings.data = {};
        if (filter) { _ajaxSettings.data.filter = filter.join(';');  }
        if (limit) {
            if ( typeof limit === 'object') {
                for (var key in limit) {
                    tmpLimitArray.push( key+':'+limit[key] );
                }
                _ajaxSettings.data.limit = tmpLimitArray.join(';');
            } else {
                _ajaxSettings.data.limit = limit;
            }
        }
        if (search) { _ajaxSettings.data.query = search; }
        if (noLast) { _ajaxSettings.data.noLast = true; }
        if (noCustom) { _ajaxSettings.data.noCustom = true; }
        this.clearQueryObject();
        return _ajaxSettings;
    }

    var fn = ConceptsService;
    fn.queryObject = {};
    fn.limit = function(conceptNameOrValue, value) {
        //If passed just one argument - it's a value that limits whole query
        var limits = this.queryObject.limit;
        if ( value === undefined ) {
            this.queryObject.limit = parseInt(conceptNameOrValue);
        } else if ( limits && typeof limits === 'object' ) {
            this.queryObject.limit[conceptNameOrValue] = parseInt(value);
        } else {
            this.queryObject.limit = {};
            this.queryObject.limit[conceptNameOrValue] = parseInt(value);
        }
        return this;
    };
    fn.noLimit = function(conceptName) {
        //Yep, == not ===
        if ( conceptName == undefined ) {
            this.queryObject.limit = undefined;
            return this;
        }
        this.queryObject.limit[conceptName] = undefined;
        return this;
    };
    fn.search = function(searchString) {
        if ( searchString == undefined ) {
            this.queryObject.search = '';
            return this;
        }
        this.queryObject.search = searchString;
        return this;
    };
    fn.filter = function(anthologyName){
        var filter = this.queryObject.filter,
            self = this,
            anthologiesList;
        if ( anthologyName == undefined ) { return this; }

        if ( arguments.length > 1 || anthologyName instanceof Array) {
            if ( arguments.length > 1 ) {
                anthologiesList = Array.prototype.slice.call(arguments, 0);
            } else {
                anthologiesList = anthologyName;
            }
            for (var i = 0; i < anthologiesList.length - 1; i++) {
                putAnthologyInFilterList( anthologiesList[i] );
            }
        } else {
            putAnthologyInFilterList(anthologyName);
        }

        return this;

        function putAnthologyInFilterList(anthology){
            if ( !$.isArray(filter) ) { filter = self.queryObject.filter = []; }
            if ( $.inArray(anthology, filter) === -1 ) { self.queryObject.filter.push(anthology); }
        }
    };
    fn.removeFilter = function(anthologyName) {
        var filter = this.queryObject.filter,
            REMOVE_ONE_ELEMENT = 1,
            indexOfAnthology;
        if ( !$.isArray(filter) ) {
            this.queryObject.filter = [];
            return this;
        }
        indexOfAnthology = $.inArray(anthologyName, filter);
        if ( indexOfAnthology !== -1 ) {
            this.queryObject.filter.splice(indexOfAnthology, REMOVE_ONE_ELEMENT);
        } else {
            this.queryObject.filter = [];
        }
        return this;
    };
    fn.enableLast = function() {
        this.queryObject.noLast = false;
        return this;
    };
    fn.disableLast = function() {
        this.queryObject.noLast = true;
        return this;
    };
    fn.disableCustom = function() {
        this.queryObject.noCustom = true;
        return this;
    };
    fn.clearQueryObject = function() {
        this.queryObject = {};
        return this;
    };
    fn.addToLast = function (conceptID, isCustom){
        var lastConceptsUrl = this.url.replace(/concepts/,'last-concepts'),
            _isCustom = isCustom || false;
        return this.post({url :lastConceptsUrl, data: {id: conceptID, is_custom: _isCustom}});
    };

    API.registerService(ConceptsService);

    return ConceptsService;

}));